export default {
  navigationBarTitleText: '案例播放'
};
